import axios from "axios";

export async function GetCustomAccounts() {
  const response = await axios.get(`/api/v1.0/customaccount/`);
  return response.data;
}

export async function GetAccountTypes() {
  const response = await axios.get(`/api/v1.0/accounttype/`);
  return response.data;
}

export async function UpdateCustomAccount(customAccount) {
  const response = await axios.post(
    `/api/v1.0/customaccount/${customAccount.id}`,
    customAccount,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.errorMessages && response.data.errorMessages.length > 0) {
    throw response.data;
  }

  return response.data;
}

export async function CreateCustomAccount(customAccount) {
  const response = await axios.put(`/api/v1.0/customaccount/`, customAccount, {
    validateStatus: function(status) {
      return true;
    }
  });

  if (response.data.status >= 400) {
    throw response.data;
  }

  return response.data;
}

export async function DeleteCustomAccount(customAccountId) {
  const response = await axios.delete(
    `/api/v1.0/customaccount/${customAccountId}`,
    {
      validateStatus: function(status) {
        return true;
      }
    }
  );

  if (response.data.status >= 400) {
    throw response.data;
  }

  return response.data;
}
